<script lang="ts">
	export let props: {
		date: string;
		text: string;
	};
</script>

<div class="flex flex-col space-y-3 items-center px-1 lg:px-3 ">
	<div class="font-semibold text-lg">{props.date}</div>
	<div class="bg-primary rounded-full w-2 h-2" />
	<div class="text-sm text-center">{props.text}</div>
</div>
